import RelationTableModule from "components/Modules/Relations/RelationTableModule"
import {
  createOrUpdateFirestoreDocument,
  getDataFromFirestoreCollection,
} from "helpers/Firestore"
import PromotionForm from "./PromotionAddTables/PromotionForm"

const CityCampaignPromotionRelationTable = ({ opened }) => {
  return (
    <RelationTableModule
      getData={async ({ firebaseUID }) => {
        return await getDataFromFirestoreCollection({
          path: "Offers/Promotions/DataBase",
          where: [
            {
              key: "CampaignID",
              operation: "==",
              value: opened,
            },
          ],
        })
      }}
      CreateComponent={onCancel => (
        <PromotionForm parent={opened} onCancel={onCancel} />
      )}
      OpenedComponent={(ID, onCancel) => (
        <PromotionForm opened={ID} parent={opened} onCancel={onCancel} />
      )}
      deleteRelation={async (firebaseUID, x) => {
        await createOrUpdateFirestoreDocument({
          path: `Offers/Promotions/DataBase`,
          values: { ID: x.ID, Status: "Removed" },
        })
      }}
      columns={[
        { key: "Title", label: "Title" },
        { key: "Status", label: "Status" },
      ]}
      searchKey={"Title"}
    />
  )
}

export default CityCampaignPromotionRelationTable
